import api from "@virgodev/bazaar/functions/api";

const PRODUCTION_HOSTS = ["app.zioncallmgmt.com"];

// Newbook signs everyone in at login.newbook.cloud (loginstaging for the test
// region), but serves bookings from one app host per region:
// appus / appau / appeu / appap.newbook.cloud, and appstaging for the test region.
const NEWBOOK_REGIONS = ["us", "au", "ap", "eu", "staging"];
const STAGING_REGION = "staging";
const DEFAULT_REGION = "us";

const isProductionHost =
  typeof window !== "undefined" &&
  PRODUCTION_HOSTS.includes(window.location.hostname);

let facilityRegions: Promise<Record<string, string>> | null = null;

function loadFacilityRegions(): Promise<Record<string, string>> {
  if (!facilityRegions) {
    facilityRegions = api({ url: "nb/facilities/", method: "GET" })
      .then((response) => {
        const regions: Record<string, string> = {};
        if (response.ok && Array.isArray(response.body)) {
          for (const facility of response.body) {
            regions[String(facility.id)] = String(facility.newbook_region);
          }
        }
        return regions;
      })
      .catch(() => ({}));
    // Don't keep an empty result around; try again next time.
    facilityRegions.then((regions) => {
      if (Object.keys(regions).length === 0) {
        facilityRegions = null;
      }
    });
  }
  return facilityRegions;
}

export interface NewbookLinks {
  paymentLink: string;
  loginLink: string;
}

export async function buildNewbookLinks(
  bookingId: string | number,
  facilityId: string
): Promise<NewbookLinks> {
  let region = STAGING_REGION;
  if (isProductionHost) {
    const regions = await loadFacilityRegions();
    region = regions[facilityId];
    if (!NEWBOOK_REGIONS.includes(region)) {
      region = DEFAULT_REGION;
    }
  }
  const booking = encodeURIComponent(String(bookingId));
  return {
    paymentLink: `https://app${region}.newbook.cloud/bookings_view/${booking}`,
    loginLink:
      region === STAGING_REGION
        ? "https://loginstaging.newbook.cloud/"
        : "https://login.newbook.cloud/",
  };
}
